import { Box } from '@mui/material';
import AttrLabel from './AttrLabel';

function InlineLabel({ label, children }) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                '&:not(:first-of-type)': {
                    paddingTop: 2,
                },
            }}
        >
            <AttrLabel>{label}</AttrLabel>
            {children}
        </Box>
    );
}

export default InlineLabel;
